(function () {
    /**
     * For how long should we timeout the intro. Currently 24h
     * @type {number}
     */
    const timeout = 1000 * 60 * 60 * 24;
    /**
     * Key visual in the markup
     * @type {Element}
     */
    const visual = document.querySelector(".global-key-visual");

    if (visual != null) {
        // if user click on the key-visual scroll to navigation
        visual.addEventListener("click", () => {
            window.scrollTo({top: visual.clientHeight, behavior: 'smooth'});
        });

        /**
         * Makes sure, key-visual is just displayed, when user didn't already visited the page in the last 24h
         *
         * Based on @see https://codeshack.io/eu-cookie-consent-popup-javascript/?PageSpeed=noscript
         */

        // get last visit from local store or 0
        const lastVisit = parseInt(localStorage.getItem('key-visual') || 0);
        // check if the user has a newer timestamp
        if (lastVisit + timeout < Date.now()) {
            visual.classList.remove('hide');
            localStorage.setItem('key-visual', Date.now().toString());
        }
    }
})()
